import React from 'react'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

const IconButtonWithText = ({
  icon,
  iconSize,
  selected,
  onClick,
  text,
  longPressEvent = {},
  textCSS,
  label,
  labelCSS,
  iconWrapperCSS,
  wrapperCSS
}) => {
  return (
    <div className={`${styles.wrapper} ${wrapperCSS}`}>
      <button
        type='button'
        aria-label={text}
        onClick={onClick}
        className={`${styles.iconWrapper} ${iconWrapperCSS} ${
          selected ? styles.selectedIconWrapper : styles.unselectedIconWrapper
        }`}
        {...longPressEvent}>
        <Icon name={icon} size={iconSize} styleModifier={styles.icon} />
      </button>
      <span className={`${styles.text} ${textCSS} ${selected ? styles.selectedText : styles.unselectedText}`}>
        {text}
      </span>
      {label && <label className={`${styles.label} ${labelCSS}`}>{label}</label>}
    </div>
  )
}

export default IconButtonWithText
